import { useEffect } from 'react';
import { useDetailsBooking } from 'lib/hooks';
import useQffUser from 'hooks/useQffUser';
import { FLAG_LIVE_CHAT_ENABLED } from 'config/env';
import { preFillLiveChat, LIVE_CHAT_ANCHOR_ID } from 'lib/liveChat';
import { Global, css } from '@emotion/core';

const LiveChat = () => {
  const { qffUser } = useQffUser();
  const { booking } = useDetailsBooking();

  useEffect(() => {
    if (FLAG_LIVE_CHAT_ENABLED && booking) {
      preFillLiveChat({
        name: `${booking.reservation.leadGuest.name.given} ${booking.reservation.leadGuest.name.family}`,
        emailAddress: booking.travelArranger.email,
        phoneNumber: booking.travelArranger.phone,
        bookingReference: booking.reference,
        accountId: qffUser?.memberId || undefined,
      });
    }
  }, [booking, qffUser?.memberId]);

  return (
    <Global
      styles={css`
        #${LIVE_CHAT_ANCHOR_ID} .embeddedServiceHelpButton .helpButton .uiButton {
          ${!!booking &&
          css`
            transform: translate(0, 0%);
          `}
        }
      `}
    />
  );
};

LiveChat.displayName = 'LiveChat';

export default LiveChat;
